
import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="text-white" style={{ backgroundColor: '#355f4e' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold text-green-400 mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              萬業人才資本
            </h3>
            <p className="text-green-400 mb-4">Omni Workforce</p>
            <p className="text-gray-400 mb-4">
              專業外勞招聘服務，持有香港職業介紹所牌照，超過十年經驗，為香港僱主提供一站式外勞招聘解決方案。
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">服務項目</h4>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#" className="hover:text-green-400 transition-colors">外勞配額申請</a></li>
              <li><a href="#" className="hover:text-green-400 transition-colors">簽證申請代辦</a></li>
              <li><a href="#" className="hover:text-green-400 transition-colors">專業培訓服務</a></li>
              <li><a href="#" className="hover:text-green-400 transition-colors">宿舍管理方案</a></li>
              <li><a href="#" className="hover:text-green-400 transition-colors">生活支援服務</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">聯絡資訊</h4>
            <div className="space-y-3 text-gray-400">
              <div className="flex items-start">
                <i className="ri-map-pin-line text-green-400 mt-1 mr-2"></i>
                <div className="text-sm">
                  <div>灣仔灣仔道133號卓凌中心11樓</div>
                  <div className="mt-1">11/F, TIMES MEDIA CENTRE,<br />133 WANCHAI ROAD,<br />WANCHAI, HONG KONG</div>
                </div>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-green-400 mr-2"></i>
                <a href="mailto:omnisourcetalent@gmail.com" className="hover:text-green-400 transition-colors text-sm">
                  omnisourcetalent@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <p className="text-gray-400 text-sm text-center">
            © 2025 萬業人才資本 Omni Workforce. 版權所有。
            <a href="https://readdy.ai/?origin=logo" className="ml-4 hover:text-green-400 transition-colors">Website Builder</a>
          </p>
        </div>
      </div>
    </footer>
  );
};
